// https://sipjs.com/
import store from "@/store/index";
import { eventBus } from "@/utils/helper/eventBus";
import { Message } from "element-ui";
import { callerWindowState } from "@/utils/helper/caller.window.state";
import { updateAgentState } from "@/api/interface/cti";
// import { agentLoginRecord } from "@/api/interface/work";
import { parseJSON } from '@/utils/base';
import __config from '@/config';
const { apiEnv, apiPrefixGroup, fileVersion } = __config;

export class rgybHelper {
  rgybHelperUA = undefined; //sip实例
  currentCallCustomerId = ""; // (电销：当前customerId) / (智保云400：当前工单ID)
  sessionall = null;
  instanceId = null;  //callId
  customerNumber = null;  //客户手机号
  customerName = null;  //客户姓名
  hasEmitRinging = false; //是否触发过响铃
  origin = 'hnzj';  //本话务类型
  constructor(props) {
    // setTimeout(() => {this.logOut();}, 5000);  //测试断线重连
  }
  // 注册
  register(registerOption) {
		// 注册配置
    const {lusUserCti={}} = store.state.global;
    const {cno, password} = lusUserCti;

    const config = {
      uri: `sip:${cno}@${apiPrefixGroup.initFsHost[apiEnv]}`, //地址
      authorizationUser: cno, //分机号
      password, //分机密码
      hackWssInTransport: true, // 设置为true 则注册时 transport=wss; false:transport=ws;
      transportOptions: {
        wsServers: [`wss://${apiPrefixGroup.initFsHost[apiEnv]}:7443`], //wss协议
        traceSip: true, //开启sip日志,用于排查问题
      },
      register: true,
      registerOptions: {
        expires: 3600 * 10, // 注册有效期设为 3600 秒（1小时）
      },
      log: {
        builtinEnabled: true,
        level: 1, // log日志级别
        // level: 'debug',
      },
      sessionTimers: true,
      sessionTimersExpires: 3600
    }
    console.log('fs-注册参数 =>', {...config}, {...lusUserCti});

    // 初始化并注册一个UAC到服务器
    this.rgybHelperUA = new window.SIP.UA(config);

    //监听-注册失败
    this.rgybHelperUA.on("registrationFailed", (response, cause) => {
      console.error("fs-注册失败-registrationFailed =>", response, cause);
      callerWindowState.ctiStatus = `座席注册失败`;
    });

		// 监听-注册成功
    this.rgybHelperUA.on("registered", (response) => {
      console.log('fs-注册成功-registered =>', response);
      callerWindowState.ctiStatus = `在线`;
      // 坐席取缓存状态
      const storeCtiStatus = sessionStorage.getItem('__store_ctiStatus');
      if (storeCtiStatus){
        if (storeCtiStatus !== 'unpause'){
          if (storeCtiStatus === 'pause') ; callerWindowState.ctiStatus = '忙碌';
          if (storeCtiStatus === 'logOut') ; callerWindowState.ctiStatus = '离线';
          this[storeCtiStatus] && this[storeCtiStatus]();
        }
      } else {
        if (lusUserCti.roleLevel > 1) this.pause();
      }

      // agentLoginRecord({});  //坐席登录记录
      eventBus.$emit('onRegisterSuccess');
    });

		// 监听-注销成功
    this.rgybHelperUA.on("unregistered", (response) => {
      console.log('fs-注销成功-unregistered =>', response);
      callerWindowState.ctiStatus = "离线";
      eventBus.$emit('onUnregisteredSuccess');
    });

    // 监听-消息
    this.rgybHelperUA.on("message", (message) => {
      const jsonObject = parseJSON(message.body);
      console.warn("fs-接收消息-message =>", message, jsonObject);
    });

    // 监听-接受呼入会话入站（用户代理服务器）
    this.rgybHelperUA.on("invite", (session) => {
      console.warn("fs-接受呼入会话入站-invite =>", session);
      const jsonObject = session.request
      const _self = this;
      // var url = session.remoteIdentity.uri.toString() + "来电了，是否接听";

      // 播放来电铃声
      const playAudio = document.getElementById("messageTipMusic");
      const remoteVideo = document.getElementById("remoteVideo");
      const localVideo = document.getElementById("localVideo");
      playAudio.src = `https://static-rc.heiniubao.com/files/fs_callin_ring.mp3?${fileVersion}`;
      playAudio.play();

      this.currentCallCustomerId = jsonObject.getHeader('X-customerId'); //客户ID / 工单ID
      this.customerName = jsonObject.getHeader('X-customerName'); //客户姓名
      this.instanceId = jsonObject.getHeader('X-callId'); //callId
      this.customerNumber = jsonObject.getHeader('X-calledNum');  //客户手机号
      callerWindowState.convId = jsonObject.getHeader('X-nodeMessage'); //转人节点
      callerWindowState.callWindowStatus = "ON_FORWARDING"; //状态改为转人中
      // eventBus.$emit("resetCustomerListForEmpty")

      // 触发-响铃回调
      eventBus.$emit("ringing", {
        origin: this.origin,
        params: {
          instanceId: this.instanceId, // callId
          customerId: this.currentCallCustomerId,  //客户ID / 工单ID
          customerName: this.customerName,
          customerNumber: this.customerNumber,
        },
      });

      // 监听-接收
      session.on("accepted", function (response, cause) {
        console.warn("fs-接听-accepted =>", response, cause);
        var pc = this.sessionDescriptionHandler.peerConnection;

        // 对方视频
        var remoteStream;
        if (pc.getReceivers) {
          remoteStream = new window.MediaStream();
          pc.getReceivers().forEach(function (receiver) {
            var track = receiver.track;
            if (track) remoteStream.addTrack(track);
          });
        } else {
          remoteStream = pc.getRemoteStreams()[0];
        }
        remoteVideo.srcObject = remoteStream;

        // 我方视频
        var localStream_1;
        if (pc.getSenders) {
          localStream_1 = new window.MediaStream();
          pc.getSenders().forEach(function (sender) {
            var track = sender.track;
            if (track && track.kind === "video") localStream_1.addTrack(track);
          });
        } else {
          localStream_1 = pc.getLocalStreams()[0];
        }
        localVideo.srcObject = localStream_1;
        localVideo.volume = 0;

        // 触发-系统坐席接听后回调
        eventBus.$emit("agentSipLink", {
          origin: _self.origin,
          instanceId: _self.instanceId,
          phoneNumber: _self.customerNumber,
        });


        eventBus.$emit("onPreviewOutcallBridgeBusyOb"); // 触发-用户接通回调
        _self.resetRingAduio();  //关闭响铃
      });

      // 监听-前端处理系统挂断
      session.on("bye", (resp, cause) => {
        console.warn("fs-bye-接听 =>", resp, cause);
        this.clearStatus();
      });

      // 监听-挂断
      session.on("terminated", (message, cause) => {
        console.warn("fs-接听-terminated =>", message, cause);
        this.clearStatus();
      });

      this.sessionall = session;
      // this.sipLink();
    });
  }
  // 坐席外呼，坐席人员主动发起外呼。坐席状态只有在空闲、忙碌状态下才能进行外呼。
  makeCall(phoneNumber, callOption={}) {
    console.log("makeCall =>", phoneNumber, callOption, {...this.rgybHelperUA});
    console.log('callerWindowState =>', {...callerWindowState});

    const _self = this;
    const {
      jobOrderId: currentCallCustomerId,
      name,
      realPhone,
      callId,
    } = callOption;
    const {ctiStatus} = callerWindowState;

    this.hasEmitRinging = false;
    this.currentCallCustomerId = currentCallCustomerId; //客户ID / 工单ID
    callerWindowState.currentCallCustomerRealName = name; //客户外显名字

    if (ctiStatus === "离线") {
      Message.error("呼叫系统尚未初始化完成");
      eventBus.$emit("fail", {callId, errMsg: "呼叫系统尚未初始化完成"});
      return;
    }

    // 播放外呼铃声
    const playAudio = document.getElementById("messageTipMusic");
    const remoteVideo = document.getElementById('remoteVideo');
    const localVideo = document.getElementById('localVideo');
    playAudio.src = `https://static-rc.heiniubao.com/files/fs_callout_ring.mp3?${fileVersion}`;

    // 外拨呼号
    const payload = {
      extraHeaders: [
        `X-customerId: ${currentCallCustomerId}`, // 自定义用户标识头
        `X-customerName: ${name}`,  // 其他自定义头
      ],
      sessionDescriptionHandlerOptions: {
        constraints: {audio: true, video: false},
        alwaysAcquireMediaFirst: true, //此参数是sip.js官方修复在firefox遇到的bug所设置
      },
    }
    const sessionall = this.rgybHelperUA.invite(realPhone, payload);
    this.sessionall = sessionall;

    // 接收。每次收到成功的最终（200-299）响应时都会触发。
    sessionall.on("accepted", function (response, cause) {
      console.warn("fs-外呼-accepted =>", response, cause);
      var pc = this.sessionDescriptionHandler.peerConnection;

      // 对方视频
      var remoteStream;
      if (pc.getReceivers) {
        remoteStream = new window.MediaStream();
        pc.getReceivers().forEach(function (receiver) {
          var track = receiver.track;
          if (track) remoteStream.addTrack(track);
        });
      } else {
        remoteStream = pc.getRemoteStreams()[0];
      }
      remoteVideo.srcObject = remoteStream;

      // 我方视频
      var localStream_1;
      if (pc.getSenders) {
        localStream_1 = new window.MediaStream();
        pc.getSenders().forEach(function (sender) {
          var track = sender.track;
          if (track && track.kind === "video") localStream_1.addTrack(track);
        });
      } else {
        localStream_1 = pc.getLocalStreams()[0];
      }
      localVideo.srcObject = localStream_1;
      // localVideo.volume = 0;

      eventBus.$emit("callAnswer", {});
      eventBus.$emit("onPreviewOutcallBridgeBusyOb"); //触发-用户接通回调
      _self.resetRingAduio();  //关闭响铃
    });

    // 对方拒绝
    sessionall.on("rejected", (message, cause) => {
      console.warn("fs-外呼-rejected =>", message, cause);
      this.clearStatus();
    });

    // 前端处理系统挂断后逻辑
    sessionall.on("bye", (resp, cause) => {
      console.warn("fs-外呼-bye =>", resp, cause);
      this.clearStatus();
    });

    // 请求失败时回调，无论是由于最终响应失败，还是由于超时，传输或其他错误。
    sessionall.on("failed", (response, cause) => {
      console.warn('fs-外呼-failed =>', response, cause);
        this.clearStatus();
    })

    // 挂断
    sessionall.on("terminated", (message, cause) => {
      console.warn("fs-外呼-terminated =>", message, cause);
      this.clearStatus();
    });

    sessionall.on('progress', function (response) {
      console.warn('fs-外呼-progress =>', response, this);
      playAudio.play();

      if (!_self.hasEmitRinging) {
        _self.hasEmitRinging = true;
        // 触发-响铃回调
        eventBus.$emit("ringing", {
          origin: _self.origin,
          params: {
            isCallOut: true, //电话是否外呼类型
            instanceId: response.callId,
            customerId: currentCallCustomerId,
            customerName: name,
            customerNumber: realPhone,
          },
        });

        eventBus.$emit("ring", {
          origin: _self.origin,
          params: {
            instanceId: response.callId,
            customerId: currentCallCustomerId,
          }
        });
      }

      if (response.statusCode === 183 && response.body && this.hasOffer && !this.dialog) {
        if (!response.hasHeader('require') || response.getHeader('require').indexOf('100rel') === -1) {
          if (this.sessionDescriptionHandler.hasDescription(response.getHeader('Content-Type'))) {
            if (!this.createDialog(response, 'UAC')) return;
            this.hasAnswer = true
            this.dialog.pracked.push(response.getHeader('rseq'))
            this.status = window.SIP.Session.C.STATUS_EARLY_MEDIA

            this.sessionDescriptionHandler
              .setDescription(response.body, this.sessionDescriptionHandlerOptions, this.modifiers)
              .catch((reason) => {
                console.warn(reason);
                this.failed(response, window.SIP.C.causes.BAD_MEDIA_DESCRIPTION)
                this.terminate({ status_code: 488, reason_phrase: 'Bad Media Description' })
              })
          }
        }
      }
    });
  }
  // 坐席挂断 - 坐席人员主动挂断当前通话
  hangup() {
    // 前端处理系统挂断后逻辑
    this.instanceId = "";
    eventBus.$emit("hangup", {});
    document.getElementById("messageTipMusic").pause();
    document.getElementById("messageTipMusic").currentTime = 0;
    console.log('rgyb.helper-hangup =>', this.sessionall);

    if (!this.sessionall) {
      return;
    } else if (this.sessionall.startTime) {
      // Connected
      this.sessionall.bye();
    } else if (this.sessionall.reject) {
      // Incoming
      this.sessionall.reject();
    } else if (this.sessionall.cancel) {
      // Outbound
      this.sessionall.cancel();
    }
  }
  // 坐席操作 - 呼叫(呼入)接听
  sipLink() {
    console.log('呼叫接听 sipLink =>');

    this.sessionall.accept({
      sessionDescriptionHandlerOptions: {
        constraints: {
          audio: true,
          video: false,
        },
      },
    });
  }
  // 坐席操作 - 呼入拒接
  refuse() {
    if (!this.sessionall) {
      return;
    } else if (this.sessionall.startTime) {
      // Connected
      this.sessionall.bye();
    } else if (this.sessionall.reject) {
      // Incoming
      this.sessionall.reject();
    } else if (this.sessionall.cancel) {
      // Outbound
      this.sessionall.cancel();
    }
  }
  // 设置忙碌
  pause(flag) {
    updateAgentState({
      attendNumber: store.state.global.lusUserCti.cno,
      attendStatus: 3,
    }).then((res) => {
      if (res.code == "000000") {
        callerWindowState.ctiStatus = "忙碌";
        if (flag) eventBus.$emit('logOut', flag);
      }
    });
  }
  // 设置在线()
  unpause() {
      this.register();
    // if (['离线', '座席注册失败'].includes(callerWindowState.ctiStatus)) {
    //   return
    // }
    // updateAgentState({
    //   attendNumber: store.state.global.lusUserCti.cno,
    //   attendStatus: 2,
    // }).then((res) => {
    //   if (res.code == "000000") {
    //     callerWindowState.ctiStatus = "在线";
    //     eventBus.$emit('onRegisterSuccess');
    //   }
    // });
  }
  // 呼叫保持，通话时坐席操作呼叫保持后，用户端收听背景音，坐席可以与其他人讲话（用户听不到坐席侧的声音）
  holdCall() {
    if (!this.sessionall) return;
    this.sessionall.hold();
    callerWindowState.muting = true;
  }
  // 取消呼叫保持，保持中的通话，坐席可以取消呼叫保持，取消后，用户端恢复与坐席正常的双向通话（彼此听到对方声音）
  unHold() {
    if (!this.sessionall) return;
    this.sessionall.unhold();
    callerWindowState.muting = false;
  }
  // 坐席操作、开启自动外呼
  startAutoDial() {
    eventBus.$emit("startAutoDial", {})
  }
  // 坐席操作、关闭自动外呼
  closeAutoDial() {
    eventBus.$emit("closeAutoDial", {})
  }
  // 退出登录
  logOut(callback) {
    const {rgybHelperUA, sessionall} = this;
		if (rgybHelperUA && rgybHelperUA.unregister) rgybHelperUA.unregister();
    if (sessionall && sessionall.disconnect) sessionall.disconnect();
    updateAgentState({
      attendNumber: store.state.global.lusUserCti.cno,
      attendStatus: 1,
    })
    eventBus.$emit('logOut');
  }
  // 清除状态
  clearStatus(){
    this.resetRingAduio();
    this.instanceId = "";
    this.hasEmitRinging = false;
    eventBus.$emit("hangup", {});
  }
  // 重置响铃音频
  resetRingAduio(){
    const playAudio = document.getElementById("messageTipMusic");
    if (!playAudio) return;
    playAudio.pause();
    playAudio.currentTime = 0;
  }

  // 绑定坐席
  // bindSeat(){
  //   postDesignate({
  //     batchIdList: [],
  //     saleState: null,
  //     designateList: [{
  //       agentId: localStorage.getItem("agentId"),
  //       num: 1,
  //     }],
  //     customerIdList: [this.currentCallCustomerId]
  //   })
  // }
}


